export const ADMIN_TAXES_RECEIVED = 'ADMIN_TAXES_RECEIVED'
export const ADMIN_TAXES_UPDATED = 'ADMIN_TAXES_UPDATED'
export const ADMIN_TAXES_UNLOADED = 'ADMIN_TAXES_UNLOADED'
